import { MouseEvent, useState } from 'react';

const ROLLBACK_DURATION_MS = 100;

function usePreventClickOnDrag() {
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const beforeChange = () => setIsDragging(true);
    const afterChange = () => {
        const timeout = setTimeout(() => {
            setIsDragging(false);
        }, ROLLBACK_DURATION_MS);
        return () => clearTimeout(timeout);
    };

    const onDragItemClick = (onClick?: () =>void) => {
        if (!isDragging) {
            onClick?.();
        }
    };
    return {
        beforeChange, afterChange, onDragItemClick,
    };
}

export default usePreventClickOnDrag;
